import { type TranslationTree } from '@/i18n/types';

export const messages = {
  loadError: 'Não foi possível carregar o evento',
  submitted: 'Evento enviado para análise',
  canceled: 'Evento cancelado',
  deleted: 'Evento apagado',
  cancelModal: {
    title: 'Cancelar evento',
    // pt-BR reads 0 as "one"; the zero form keeps the sentence right.
    message: {
      zero: 'Ninguém confirmou presença ainda. O evento sai do app e o cancelamento não pode ser desfeito.',
      one: '{{count}} pessoa pretende ir. Ela vai ver o evento como cancelado, e o cancelamento não pode ser desfeito.',
      other:
        '{{count}} pessoas pretendem ir. Elas vão ver o evento como cancelado, e o cancelamento não pode ser desfeito.',
    },
    confirm: 'Cancelar evento',
    back: 'Voltar',
  },
  deleteModal: {
    title: 'Apagar evento',
    message: 'O evento, o endereço e o histórico serão apagados. Esta ação não pode ser desfeita.',
    confirm: 'Apagar',
    back: 'Voltar',
  },
} satisfies TranslationTree;
